import utils from '@/services/utils';

export default {
  fetchManagerList(schoolId) {
    return utils
      .get('/api/school/account/getManagerList', {
        school_id: schoolId,
      }, '加载中···');
  },
  batchCreateManager(managerList) {
    return utils
      .post('/api/school/account/createManagers', {
        manager_list: managerList,
      }, '创建中···');
  },
  toggleFreezeManager(manager, schoolId, password) {
    return utils
      .post('/api/school/account/freezeManager', {
        manager_id: manager.id,
        school_id: schoolId,
        is_freeze: manager.is_freeze ? 0 : 1,
        password,
      }, '修改中···');
  },
  deleteManager(manager, schoolId, password) {
    return utils
      .post('/api/school/account/deleteManager', {
        manager_id: manager.id,
        school_id: schoolId,
        password,
      }, '删除中···');
  },
};



// WEBPACK FOOTER //
// ./src/services/modules/school/school-detail/manager.js